// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import 'babel-polyfill'
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import Buefy from 'buefy';

// Font awesome
import fontawesome from '@fortawesome/fontawesome';
import faSolid from '@fortawesome/fontawesome-free-solid';
import faRegular from '@fortawesome/fontawesome-free-regular';
import faBrands from '@fortawesome/fontawesome-free-brands';

import router from './router';
import bus from './bus';
import App from './App.vue';

// Global components
import window from './components/partials/Window.vue';

import './registerServiceWorker';

fontawesome.library.add(faSolid);
fontawesome.library.add(faRegular);
fontawesome.library.add(faBrands);

Vue.use(Buefy);
Vue.use(ElementUI, { locale });
Vue.component('window', window);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  bus.$emit('closeSidebar');
  next();
});

router.afterEach(() => {
  bus.$emit('resetExpandedItem');
});


new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
